import { render, staticRenderFns } from "./ChatwootTeste.vue?vue&type=template&id=b0247df2&scoped=true&"
import script from "./ChatwootTeste.vue?vue&type=script&lang=js&"
export * from "./ChatwootTeste.vue?vue&type=script&lang=js&"
import style0 from "./ChatwootTeste.vue?vue&type=style&index=0&id=b0247df2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0247df2",
  null
  
)

export default component.exports